import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Button } from '../Button';
import { Container } from '../Container';
import { SectionTitle } from '../Section';

export const StyledContainer = styled(Container)`
  margin-top: 75px;
  margin-bottom: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const Image = styled.img<{ imageOnLeft: boolean }>`
  padding-right: ${({ imageOnLeft }) => (imageOnLeft ? 100 : 0)}px;
  padding-left: ${({ imageOnLeft }) => (imageOnLeft ? 0 : 100)}px;
  width: 50%;
  height: auto;
  object-fit: contain;
  max-height: 500px;
  order: ${({ imageOnLeft }) => (imageOnLeft ? -1 : 1)};
  ${mediaQuery('tablet')} {
    /* display: none; */
    margin-bottom: 30px;
    padding: 0 20px;
    order: -1;
    width: auto;
    max-width: 300px;
  }
  ${mediaQuery('phone')} {
    max-width: 200px;
  }
`;

export const ContentWrapper = styled.div`
  text-align: left;
  width: 50%;
  ${mediaQuery('tablet')} {
    width: 100%;
    text-align: center;
  }
`;

export const Title = styled(SectionTitle)`
  margin-bottom: 10px;
`;

export const Subtitle = styled.h3<{ color?: 'blue' | 'purple' }>`
  ${responsiveFontSize(20, 1)}
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color[props.color ?? 'blue'].default};
  margin-bottom: 10px;
  margin-top: 20px;
`;

export const ChildrenWrapper = styled.div`
  margin-top: 30px;
`;

export const BookingButton = styled(Button)`
  a {
    color: inherit;
  }
`;
